import { render, staticRenderFns } from "./attributeSearch.vue?vue&type=template&id=20467a51&scoped=true"
import script from "./attributeSearch.vue?vue&type=script&lang=js"
export * from "./attributeSearch.vue?vue&type=script&lang=js"
import style0 from "./attributeSearch.vue?vue&type=style&index=0&id=20467a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20467a51",
  null
  
)

export default component.exports